import React, { useState } from 'react';
import './Navbar.css';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const logoUrl = "https://blacksalt.ascentbw.com/Images/TagLogo.png";
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const navLinks = [
    { name: "ABOUT", href: "#about" },
    { name: "GALLERY", href: "#gallery" },
    { name: "SALE", href: "#sale", isNew: true },
    { name: "CONTACT", href: "#contact" },
  ];

  return (
    <>
      <motion.nav 
        className="navbar"
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <div className="nav-links desktop-only">
          {navLinks.map((link) => (
            <a key={link.name} href={link.href} className={link.isNew ? 'sale-link' : ''}>
              {link.name}
              {link.isNew && <span className="badge-new">NEW</span>}
            </a>
          ))}
        </div>

        <div className="nav-logo">
          <img src={logoUrl} alt="TAG Logo" />
        </div>

        <div className="nav-actions">
          <div className="search-bar desktop-only">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            <input type="text" placeholder="SEARCH" />
          </div>
          <div className={`menu-toggle ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div 
            className="mobile-menu"
            initial={{ opacity: 0, y: -100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <div className="mobile-nav-links">
              {navLinks.map((link, index) => (
                <motion.a 
                  key={link.name} 
                  href={link.href}
                  onClick={() => setIsOpen(false)}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1 * index }}
                >
                  {link.name}
                  {link.isNew && <span className="badge-new-mobile">NEW</span>}
                </motion.a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
